  <div *ngIf="isSkpModalShown"
    [config]="{ show: true, backdrop: 'static' }"
    (onHidden)="onHidden()"
    bsModal
    #autoShownModal="bs-modal"
    class="modal fade vault-add-cme-container"
    tabindex="-1"
    role="dialog"
    aria-hidden="true">
    <div class="custom-theme-modal modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content" >
        <div class="modal-header">
          <span class="close-detail"
            (click)="hideModal()"
            [eventTracker]='{"category":mls.googleEventText.add_skp_points.category,"action":mls.googleEventText.add_skp_points.key1,"product_type":"", "product_id":""}'>
            <img src="assets/themes/icons/cancel.svg" alt="close icon">
          </span>
          <p class="heading-4">
            <span class="color-grey-700">{{mls.languageText.add_skp_points.key1}}<span *ngIf="mls?.is_lskey_display==1">(add_skp_points.key1)</span></span>
         </p>
        </div>
        <div class="modal-body py-3">
          <div class="mb-3">
            <div class="form-input" [ngClass]="{'error': error_msg?.title !==''}">
              <label class="paragraph input-label">{{mls.languageText.add_skp_points.key2}}<span *ngIf="mls?.is_lskey_display==1">(add_skp_points.key2)</span>
              </label>
              <input class="input-field"
                [(ngModel)]="title"
                (keyup)="resetErrorMsg()"
                type="text"
                placeholder="{{mls.languageText.add_skp_points.key9}}"
                value=""/>
              <p class="secondary-paragraph"
                *ngIf="error_msg?.title!=''"><span class="color-error">{{error_msg?.title}}</span></p>
            </div>
          </div>

          <div class="single-dropdown form-input mb-3">
            <label class="paragraph input-label">{{mls.languageText.add_skp_points.key3}}<span *ngIf="mls?.is_lskey_display==1">(add_skp_points.key3)</span>
            </label>
                <angular2-multiselect
                  [data]="dropdownList"
                  [(ngModel)]="selectedItems"
                  [settings]="dropdownSettings"
                  (onSelect)="onItemSelect($event)"
                  (onDeSelectAll)="onSelectAll($event)">
                  <c-badge>
                    <ng-template let-item="item">
                      <div>{{item.source_type}}</div>
                    </ng-template>
                  </c-badge>
                  <c-item>
                    <ng-template let-item="item" class="new">
                      <div>{{item.source_type}}</div>
                    </ng-template>
                  </c-item>
                </angular2-multiselect>
            </div>
          <label class="secondary-paragraph" *ngIf="error_msg?.source!=''"><span class="color-error">{{error_msg?.source}}</span></label>


          <div class="mb-2 form-input" [ngClass]="{'error': error_msg?.title !==''}">
            <label class="paragraph input-label">{{mls.languageText.add_skp_points.key4}}
              <span *ngIf="mls?.is_lskey_display==1">(add_skp_points.key4)</span></label>
              <input (keyup)="validate_points($event)"
                id="frm_points"
                type="text"
                class="input-field"
                placeholder="{{mls.languageText.add_skp_points.key10}}"
                value="{{skpPointData?.data?.total_points?.score}}" />
            <p class="secondary-paragraph" *ngIf="error_msg?.point!=''"><span class="color-error">{{error_msg?.point}}</span></p>
          </div>

        <div class="row">
          <div class="mb-3 col-md-6 form-input">
            <label class="paragraph input-label">{{mls.languageText.add_skp_points.key5}}<span *ngIf="mls?.is_lskey_display==1">(add_skp_points.key5)</span>
            </label>
            <app-datepicker
              (setDate)=setDate($event)
              [defaultVal]="default_start_date"
              [minDate]="sminDate"
              [maxDate]="smaxDate"
              [dateFor]="'startDate'"
              [isvalid]="isValidStartDate"
              [isDisabled]="is_disable_start_date"
              [plhldr]="start_date_placeholder"
              [errMsg]="start_date_err_msg"
              [dpPlacement]="'top'">
            </app-datepicker>
            <div class="color-error" id="err_date"></div>
          </div>

          <div class="mb-3 col-md-6 form-input">
              <label class="paragraph input-label">{{mls.languageText.add_skp_points.key6}}<span *ngIf="mls?.is_lskey_display==1">(add_skp_points.key6)</span>
              </label>
              <app-datepicker
                (setDate)=setDate($event)
                [defaultVal]="default_end_date"
                [minDate]="eminDate"
                [maxDate]="emaxDate"
                [dateFor]="'endtDate'"
                [isvalid]="isValidEndDate"
                [isDisabled]="is_disable_end_date"
                [plhldr]="end_date_placeholder"
                [errMsg]="end_date_err_msg"
                [dpPlacement]="'top'">
              </app-datepicker>
              <div class="color-error" id="err_edate"></div>
          </div>

        </div>
        <label class="secondary-paragraph" *ngIf="error_msg?.start_date!=''"><span class="color-error">{{error_msg?.start_date}}</span></label>
        <label class="secondary-paragraph" *ngIf="error_msg?.end_date!=''"><span class="color-error">{{error_msg?.end_date}}</span></label>

        <label class="file-upload"
          for="college_id"
          *ngIf="this.dss.temp_post_media.length==0" >
          <div class="file-upload-box"
            [eventTracker]='{"category":mls.googleEventText.add_skp_points.category,"action":mls.googleEventText.add_skp_points.key2,"product_type":"", "product_id":""}'>
            <input  id="college_id"
              type="file"
              (change)="onSelectFile($event)"
              name="college-id"
              class="d-none"
              accept=" image/jpeg, image/png,image/webp, application/pdf"  />
            <span>
              <img src="assets/themes/images/upload-cam.svg" alt="icon" />
            </span>
            <p class="primary-small">
              <span>{{mls.languageText.add_skp_points.key7}}
              <span *ngIf="mls?.is_lskey_display==1">(add_skp_points.key7)</span></span>
            </p>
          </div>
          <p class="secondary-paragraph" *ngIf="error_msg?.certificate!=''"><span class="color-error">{{error_msg?.certificate}}</span></p>
        </label>

        <!-- upload preview -->
        <div class="position-relative university-preview mb-3 post-img-preview rounded"
          [hidden]="!dss.temp_post_media.length>0">
          <a class="cursor-pointer close-icon bg-light-border"
            (click)="removeCertificate()">
            <img src="assets/themes/icons/cancel.svg"/>
          </a>
          <img [src]="dss.temp_post_media[0]?.local"
            onerror="this.src='assets/images/grandround/image_placeholder.svg';"
            class="post-img-preview-img rounded-corners-12"/>
        </div>
        <!-- end upload preview -->

<!-- <span style="margin-left:50%; margin-bottom: 10px;" *ngIf="uploadFile_api_in_process==true" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>  -->


        <button (click)="fileUploadingProcess()"
        [eventTracker]='{"category":mls.googleEventText.add_skp_points.category,"action":mls.googleEventText.add_skp_points.key3,"product_type":"", "product_id":""}'
        class="btn-design medium filled w-100 pt-2 pb-2 mt-3">
          <span *ngIf="uploadFile_api_in_process==true"
            class="spinner-border spinner-border-sm"
            role="status" aria-hidden="true">
          </span>{{mls.languageText.add_skp_points.key8}}
          <span *ngIf="mls?.is_lskey_display==1">(add_skp_points.key8)</span></button>
        </div>
      </div>
    </div>
  </div>
